import axios from 'axios'
import AccountService from '../../services/AccountService'
import VueCookies from 'vue-cookies'

export const state = {
  user: {},
  token: localStorage.getItem('token') || '',
  status: '',
  isLoggedIn: !!localStorage.getItem('token')
}

export const mutations = {
  LOGGING_IN(state) {
    state.pending = true;
  },
  SET_USER_DATA(state, data) {
    // console.log('logging in with data:', data)
    let { token, firstName, lastName } = data
    localStorage.setItem('token', token)
   // SET UP COOKIES//
    VueCookies.set('token' , token, {
      maxAge: 900000,
      path: '/',
      httpOnly: false,
      secure: false // <-- false here when served over HTTP
}); 
    ///.....//

    let tokenPayloadJson = Buffer.from(token.split('.')[1], 'base64').toString()
    let tokenPayload = JSON.parse(tokenPayloadJson)
    let user = { ...tokenPayload.user, firstName: firstName, lastName: lastName }
    state.user = user
    state.isLoggedIn = true;
    state.pending = false;

    localStorage.setItem('user', JSON.stringify(user))

    // console.log('called SET_USER_DATA')

    axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`
   
  },
  CLEAR_USER_DATA() {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    this.$cookies.remove('token')  //! doesnt work!! //

    location.reload()
    state.isLoggedIn = false;
  },
}

export const actions = {
  // eslint-disable-next-line no-unused-vars
  register({ commit }, credentials) { // eslint-disable-line no-unused-vars
    return axios
      .post(`${process.env.VUE_APP_API_URL}/register`, credentials)
  },
  loginGuest({ commit }, credentials) { // eslint-disable-line no-unused-vars
    return new Promise((resolve, reject) => {
      axios
      .post(`${process.env.VUE_APP_API_URL}/register/guest`, credentials,
      { 
        baseURL: `${process.env.VUE_APP_API_URL}`,
        timeout: 5000, 
        withCredentials: true 
      })
      .then(({ data }) => {
        commit('SET_USER_DATA', data);
        return resolve(data);
      }).catch((error) => {
        throw reject(error.response);
      })
    })
  },
  registerSocialSignUpUser({ commit }, userRequest) { // eslint-disable-line no-unused-vars
    return axios
      .post(`${process.env.VUE_APP_API_URL}/register/social-signup`, userRequest)
  },
  createClient({ commit }, credentials) { // eslint-disable-line no-unused-vars
    return axios
      .post(`${process.env.VUE_APP_API_URL}/admin-panel/create-client`, credentials)
  },
  createSupport({ commit }, credentials) { // eslint-disable-line no-unused-vars
    return axios
      .post(`${process.env.VUE_APP_API_URL}/dashboard/team`, credentials)
  },
  createCleaner({ commit }, credentials) { // eslint-disable-line no-unused-vars
    return axios
      .post(`${process.env.VUE_APP_API_URL}/dashboard/team`, credentials)
  },
  login({ commit }, credentials) {
    return axios
      .post(`${process.env.VUE_APP_API_URL}/login`, credentials, { baseURL: `${process.env.VUE_APP_API_URL}`,
      timeout: 5000, 
      withCredentials: true 
    })
      .then(({ data }) => {
        commit('SET_USER_DATA', data);

        // setTimeout(() => {
        //   commit('SET_USER_DATA', data);
        //   // resolve();
        // }, 1000);
      }).catch((error) => {
        throw error.response
      })
    },
  socialLogin({ commit }, user) {
    return axios
      .post(`${process.env.VUE_APP_API_URL}/social-login`, user, { baseURL: `${process.env.VUE_APP_API_URL}`,
      timeout: 5000, 
      withCredentials: true 
    })
    .then(({ data }) => {
      commit('SET_USER_DATA', data);
    }).catch((error) => {
      throw error.response
    })
  },
  fetchUser(id) {
    return AccountService.getUser(id) // <-- Send the prop id to our AccountService//
      .then(response => {
        return response.data
      })
  },  
  logout({ commit }) {
    commit('CLEAR_USER_DATA')
  },
  forgotPassword({ commit }, credentials) { // eslint-disable-line no-unused-vars
    return axios
      .post(`${process.env.VUE_APP_API_URL}/forgot/password`, credentials)
  },
  timeapi({ commit }, publicIp) { // eslint-disable-line no-unused-vars
    return axios.get(`${process.env.VUE_APP_API_URL}/timeapi/${publicIp}`)
  }
}

export const getters = {
  loggedIn(state) {
    return state.isLoggedIn
    // return !!state.user
  },
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  token: state => state.token
}
